import { render } from "./Pivot.vue?vue&type=template&id=6005b096&scoped=true"
import script from "./Pivot.vue?vue&type=script&lang=js"
export * from "./Pivot.vue?vue&type=script&lang=js"

import "./Pivot.vue?vue&type=style&index=0&id=6005b096&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6005b096"],['__file',"src/components/pivot/Pivot.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6005b096"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6005b096', __exports__)) {
    api.reload('6005b096', __exports__)
  }
  
  module.hot.accept("./Pivot.vue?vue&type=template&id=6005b096&scoped=true", () => {
    api.rerender('6005b096', render)
  })

}


export default __exports__